import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Field } from 'react-final-form';
import styled from 'styled-components';

import * as colors from '../../../shared/colors';
import t from '../../../shared/translations';
import { ITeamScanSurvey } from './Progress';
import StatusBadge from './StatusBadge';

interface IProps {
    teamScanSurvey: ITeamScanSurvey;
    showCopied: VoidFunction;
    edit: (id: string) => void;
}

const style: React.CSSProperties = {
    color: colors.primaryColor,
};

const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &:nth-of-type(even) {
        background-color: ${colors.secondaryColor};
    }
    @media (min-width: 500px) {
        flex-direction: row;
    }
    align-items: center;
    padding: 1rem 15px 1.5rem 15px;
    margin: 0 -15px;
    @media (min-width: 1000px) {
        margin: 0;
        padding: 5px;
    }
`;

const Name = styled.div`
    width: 100%;
    margin-bottom: 0.5rem;
    @media (min-width: 600px) {
        width: 40%;
    }
    @media (min-width: 850px) {
        margin-bottom: 0;
        width: 23%;
    }
`;

const Email = styled.div`
    width: 100%;
    margin-bottom: 0.5rem;
    @media (min-width: 600px) {
        width: 60%;
    }
    @media (min-width: 850px) {
        margin-bottom: 0;
        width: 37%;
    }
`;

const Status = styled.div`
    width: 33.333%;
    svg {
        width: 80px;
        height: 24px;
    }
    @media (min-width: 800px) {
        width: 13.3%;
    }
`;

const Resend = styled.div`
    width: 33.333%;
    @media (min-width: 850px) {
        width: 13.3%;
    }
    input {
        margin-bottom: 0;
    }
    label {
        font-size: 1rem;
    }
`;

const Copy = styled.div`
    width: 33.333%;
    @media (min-width: 850px) {
        width: 13.3%;
    }
`;

function ProgressRow({ teamScanSurvey, showCopied, edit }: IProps): JSX.Element {
    return <Row>
        <Name>
            {teamScanSurvey.firstName} {teamScanSurvey.lastName}
        </Name>
        <Email>
            {teamScanSurvey.email} <span className='fake-link' onClick={() => edit(teamScanSurvey.id)} style={style}>
                {t('player.team-scan-progress.link-edit-email')}
            </span>
        </Email>
        <Status>
            <StatusBadge done={!!teamScanSurvey.datetime} />
        </Status>
        <Resend>
            {!teamScanSurvey.datetime && <label>
                <Field name={`tqs${teamScanSurvey.id}`} component='input' type='checkbox' />{' '}
                {t('player.team-scan-progress.label-resend')}
            </label>}
        </Resend>
        <Copy>
            {!teamScanSurvey.datetime && <>
                <CopyToClipboard text={teamScanSurvey.link} onCopy={showCopied}>
                    <span className='fake-link' style={style}>{t('player.team-scan-progress.link-copy-link')}</span>
                </CopyToClipboard>
            </>}
        </Copy>
    </Row>;
}

export default ProgressRow;
